import request from "@/request";
/* ------------------------------------审核管理(机构)------------------------------------ */
//任务列表
export function check_list(data) {
  return request({
    url: "publish_check/list",
    method: "post",
    data,
  });
}

//任务查看详情
export function check_detail(data) {
  return request({
    url: "publish_check/detail",
    method: "post",
    data,
  });
}

//任务审核页面
export function check_check(data) {
  return request({
    url: "publish_check/check",
    method: "post",
    data,
  });
}

//获取审核类目列表
export function category(data) {
  return request({
    url: "association_check/category",
    method: "post",
    data,
  });
}

//内容提交审核
export function check_content(data) {
  return request({
    url: "publish_check/check_content",
    method: "post",
    data,
  });
}

//编辑内容提交审核
export function save_edit_content(data) {
  return request({
    url: "publish_check/save_edit_content",
    method: "post",
    data,
  });
}

//删除内容审核
export function del_check_info(data) {
  return request({
    url: "publish_check/del_check_info",
    method: "post",
    data,
  });
}

//提交协会
export function save_check(data) {
  return request({
    url: "publish_check/save_check",
    method: "post",
    data,
  });
}

//审核任务汇总
export function task_overview(data) {
  return request({
    url: "publish_check/task_overview/?" + data,
    method: "get",
    // data
  });
}

//机构查询第一次审核信息
export function org_first_detail(data) {
  return request({
    url: "publish_check/first_detail",
    method: "post",
    data,
  });
}

/* ------------------------------------审核机构任务分配------------------------------------ */
//列表
export function check_task_list(data) {
  return request({
    url: "auditor_task/check_task_list",
    method: "post",
    data,
  });
}
//审核人员列表
export function get_auditor_user_list(data) {
  return request({
    url: "auditor_task/get_auditor_user_list",
    method: "get",
    data,
  });
}

//审核人员单个分配
export function check_task_one_allot(data) {
  return request({
    url: "auditor_task/check_task_one_allot",
    method: "post",
    data,
  });
}

//审核人员批量分配
export function check_task_batch_allot(data) {
  return request({
    url: "auditor_task/check_task_batch_allot",
    method: "post",
    data,
  });
}

/* ------------------------------------报审机构------------------------------------ */
//报审机构列表
export function org_list(data) {
  return request({
    url: "organizations/list",
    method: "post",
    data,
  });
}

//添加报审机构
export function org_add(data) {
  return request({
    url: "organizations/add",
    // contentType: ,
    headers: {
      "Content-Type": false,
    },
    method: "post",
    data,
  });
}

//删除报审机构
export function org_del(data) {
  return request({
    url: "organizations/delete",
    method: "post",
    data,
  });
}

//报审机构详情
export function org_detail(data) {
  return request({
    url: "organizations/detail",
    method: "post",
    data,
  });
}

//报审机构编辑
export function org_edit(data) {
  return request({
    url: "organizations/edit",
    method: "post",
    headers: {
      "Content-Type": false,
    },
    data,
  });
}

/* ------------------------------------初审机构------------------------------------ */
//初审任务列表
export function auditor_task_list(data) {
  return request({
    url: "auditor_task/auditor_task_list",
    method: "post",
    data,
  });
}

//获取审核机构列表-附任务统计数据
export function all_list_with_task(data) {
  return request({
    url: "publish/all_list_with_task",
    method: "get",
  });
}

//初审机构单个任务分配
export function auditor_task_one_allot(data) {
  return request({
    url: "auditor_task/auditor_task_one_allot",
    method: "post",
    data,
  });
}

//初审机构批量任务分配
export function auditor_task_batch_allot(data) {
  return request({
    url: "auditor_task/auditor_task_batch_allot",
    method: "post",
    data,
  });
}

//初审机构驳回
export function auditor_script_reject(data) {
  return request({
    url: "auditor_task/auditor_script_reject",
    method: "post",
    data,
  });
}

//初审获取元素字典的优先级
export function type_dictionary(data) {
  return request({
    url: "script/type_dictionary?" + data,
    method: "get",
    data,
  });
}

//初审设置单个优先级
export function set_task_priority(data) {
  return request({
    url: "auditor_task/set_task_priority",
    method: "post",
    data,
  });
}

//初审批量设置优先级
export function batch_set_task_priority(data) {
  return request({
    url: "auditor_task/batch_set_task_priority",
    method: "post",
    data,
  });
}

/* ------------------------------------质检列表------------------------------------ */
//质检列表
export function getQC_list(data) {
  return request({
    url: "quality_control/list",
    method: "post",
    data,
  });
}
//质检新增删除
export function save_delete_content(data) {
  return request({
    url: "quality_control/save_delete_content",
    method: "post",
    data,
  });
}

//质检合议列表
export function discussion_list(data) {
  return request({
    url: "quality_control/discussion_list",
    method: "post",
    data,
  });
}
//质检批量审核
export function all_pass(data) {
  return request({
    url: "quality_control/all_pass",
    method: "post",
    data,
  });
}
//质检合议详情
export function discussion_detail(data) {
  return request({
    url: "quality_control/discussion_detail",
    method: "post",
    data,
  });
}
/* 质检合议单个完成 */
export function agree_discussion(data) {
  return request({
    url: "quality_control/agree_discussion",
    method: "post",
    data,
  });
}
/* 质检完成合议 */
export function finish_edit(data) {
  return request({
    url: "quality_control/finish_edit",
    method: "post",
    data,
  });
}
